import React from "react";
import { ArrowRight } from "lucide-react";
import Navbar from "../components/NavLite";
import Footer from "../components/Footer";
import GoogleMe from "../components/GoogleMe";
import BgImage from "../assets/LandingPage/LandingPage1.jpg";
import Template1 from "../assets/Services/Waitlist App Template.png";
import Template2 from "../assets/Services/Booking App Template.png";
import Template3 from "../assets/Services/Nouriv Website.png";
import SecondImage from "../assets/RuthPhoto/RuthieImage.png";

const testimonials = [
  {
    name: "Jess, Leadership Coach",
    quote:
      "I didn’t just get a developer — I got a partner who understood my mission.",
  },
  {
    name: "Monique, Wellness Consultant",
    quote:
      "The MVP was live in under 3 weeks — and my clients love the private dashboard.",
  },
  {
    name: "Sasha, Doula & Educator",
    quote:
      "I launched with confidence using the Booking App — my clients love the experience.",
  },
];

export default function Prebuilt() {
  return (
    <div className="bg-[#F6F3F1] text-[#2E2D2B] font-sans">
      {/* Hero Section */}
      <section
        className="relative bg-cover bg-center bg-no-repeat px-4 sm:px-6 lg:px-8 text-center shadow-lg pb-32"
        style={{ backgroundImage: `url(${BgImage})` }}
      >
        <Navbar />
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
          Build Smarter. Launch Faster.
        </h1>
        <p className="text-lg md:text-xl mb-6 text-white">
          Skip the tech stress. Launch with a proven template or a custom MVP — made for visionary founders like you.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="/templateshop">
            <button className="bg-[#CFF09B] hover:bg-[#b6d588] text-black text-lg px-6 py-3 rounded-full">
              Explore Pre-Built Platforms
            </button>
          </a>
          <a href="https://cal.com/woaomwebdesign/15min">
            <button className="bg-[#CBBAEE] hover:bg-[#b7a7db] text-black text-lg px-6 py-3 rounded-full">
              Book a Free Discovery Call
            </button>
          </a>
        </div>
      </section>

      {/* Featured Templates */}
      <section className="px-6 py-20 bg-white">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl font-bold mb-10 text-center">
            Founder-Friendly Templates That Convert
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {[
              {
                title: "Waitlist Funnel App",
                description:
                  "Build buzz before you launch. Capture emails, validate your idea, and generate early interest.",
                img: Template1,
                link: "https://serenity-studio-template.web.app/",
              },
              {
                title: "Booking Website App",
                description:
                  "Turn interest into bookings with a clean, branded experience connected to Calendly or TidyCal.",
                img: Template2,
                link: "https://woaomtemplatetwo.web.app/",
              },
              {
                title: "Client Dashboard Template",
                description:
                  "Deliver content securely and professionally with a sleek, branded dashboard your clients will love.",
                img: Template3,
                link: "https://woaomtemplateone.web.app",
              },
            ].map((template, idx) => (
              <div
                key={idx}
                className="border border-gray-200 shadow-sm bg-[#F6F3F1]"
              >
                <img
                  src={template.img}
                  alt={template.title}
                  className="w-full h-56 object-cover mb-4"
                />
                <h3 className="text-xl font-semibold mb-2 p-2">
                  {template.title}
                </h3>
                <p className="mb-4 text-sm text-gray-700 p-2">
                  {template.description}
                </p>
                <a href={template.link} target="_blank" rel="noopener noreferrer">
                  <button className="text-[#EC6340] flex items-center gap-2 hover:underline text-sm font-medium p-2">
                    View Demo <ArrowRight size={16} />
                  </button>
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="px-6 py-20 bg-[#CBBAEE] text-black">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-bold mb-10">What Founders Are Saying</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, idx) => (
              <div key={idx} className="bg-white p-6 shadow-md text-left">
                <p className="italic mb-4">“{testimonial.quote}”</p>
                <p className="font-semibold text-sm">— {testimonial.name}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <GoogleMe />

      {/* Final CTA */}
      <section className="text-center px-6 py-20 max-w-4xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Book a Discovery Call or Start With a Template
        </h2>
        <p className="text-lg md:text-xl mb-6">
          Whether you’re just starting out or ready to scale, I’ll help bring your MVP to life with speed, clarity, and style.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="https://cal.com/woaomwebdesign/15min">
            <button className="bg-[#CFF09B] hover:bg-[#b6d588] text-black text-lg px-6 py-3 rounded-full">
              Book Your Free Call
            </button>
          </a>
          <a href="/templateshop">
            <button className="bg-[#EC6340] hover:bg-[#d0522f] text-white text-lg px-6 py-3 rounded-full">
              Explore Template Shop
            </button>
          </a>
        </div>
      </section>

      <div className="bg-[#2E2D2B]">
        <section>
          <div className="mx-auto w-full sm:p-0 p-5">
            <div className="grid gap-6 sm:gap-6 md:grid-cols-2">
              <div className="flex flex-col items-start gap-2 md:py-24 md:px-24 max-w-[700px]">
                <h4 className="mb-6 text-3xl font-semibold md:text-4xl md:mb-8 uppercase text-white">
                  Your Business Deserves Better Than a Template
                </h4>
                <p className="text-sm sm:text-xl text-white">
                  Tired of patchworking together tools that don’t fit? You’re not alone.
                  We build high-converting, custom-coded web platforms using React, Tailwind, and Firebase — crafted specifically for women growing bold, brilliant businesses.
                </p>
                <div className="flex flex-col gap-4 font-regular sm:flex-row mt-10">
                  <a
                    href="/contact"
                    className="flex rounded-full items-center gap-4 bg-[#CFF098] px-8 py-2 text-black hover:opacity-60"
                  >
                    <p>LET’S BUILD YOURS →</p>
                  </a>
                </div>
                <p className="mt-6 mb-6 text-xl italic">
                  Discover how our custom applications have helped over 200+ businesses thrive. Considering starting your app? Let's chat.
                </p>
              </div>
              <div className="relative w-full h-[]">
                <img
                  src={SecondImage}
                  alt="Portrait of a smiling women entrepreneur - Woaom Web Design"
                  className="absolute top-0 right-0 w-[500px] h-full object-cover"
                />
              </div>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
}
